import { ElementRef } from '@angular/core';
import * as i0 from "@angular/core";
export let InputRefBlockerDirective = /*#__PURE__*/(() => {
  class InputRefBlockerDirective {
    constructor(host) {
      this.host = host;
    }
    static {
      this.ɵfac = function InputRefBlockerDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || InputRefBlockerDirective)(i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: InputRefBlockerDirective,
        selectors: [["", "inputRefBlocker", ""]]
      });
    }
  }
  return InputRefBlockerDirective;
})();